var _circle, _circle2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckDeliveryEmptyPallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 34,
    r: 4,
    stroke: "#A6A6B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 4,
    stroke: "#A6A6B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 35.5C10.8284 35.5 11.5 34.8284 11.5 34C11.5 33.1716 10.8284 32.5 10 32.5V35.5ZM6 34H4.5C4.5 34.8284 5.17157 35.5 6 35.5V34ZM26 10H27.5C27.5 9.17157 26.8284 8.5 26 8.5V10ZM26 22V23.5C26.8284 23.5 27.5 22.8284 27.5 22H26ZM16 22V20.5C15.3933 20.5 14.8464 20.8655 14.6142 21.426C14.382 21.9865 14.5103 22.6317 14.9393 23.0607L16 22ZM18.9393 27.0607C19.5251 27.6464 20.4749 27.6464 21.0607 27.0607C21.6464 26.4749 21.6464 25.5251 21.0607 24.9393L18.9393 27.0607ZM21.0607 19.0607C21.6464 18.4749 21.6464 17.5251 21.0607 16.9393C20.4749 16.3536 19.5251 16.3536 18.9393 16.9393L21.0607 19.0607ZM14.9393 20.9393C14.3536 21.5251 14.3536 22.4749 14.9393 23.0607C15.5251 23.6464 16.4749 23.6464 17.0607 23.0607L14.9393 20.9393ZM10 32.5H6V35.5H10V32.5ZM7.5 34V12H4.5V34H7.5ZM7.5 12C7.5 11.7239 7.72386 11.5 8 11.5V8.5C6.067 8.5 4.5 10.067 4.5 12H7.5ZM8 11.5H26V8.5H8V11.5ZM24.5 10V22H27.5V10H24.5ZM26 20.5H16V23.5H26V20.5ZM14.9393 23.0607L18.9393 27.0607L21.0607 24.9393L17.0607 20.9393L14.9393 23.0607ZM18.9393 16.9393L14.9393 20.9393L17.0607 23.0607L21.0607 19.0607L18.9393 16.9393Z",
    fill: "#A6A6B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 34H30",
    stroke: "#A6A6B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H36L42 22V34H38",
    stroke: "#A6A6B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDeliveryEmptyPallet);
export default __webpack_public_path__ + "static/media/TruckDeliveryEmptyPallet.1267b033a098282159e1d2727346b5f3.svg";
export { ForwardRef as ReactComponent };